import React, { useCallback, useEffect, useState } from 'react';
import Header from './header/Header';
import DetailTabs from './detailTabs/DetailTabs';
import DropArea from './dropArea/DropArea';
import DiagramBuilder from '../../autom/DiagramBuilder/DiagramBuilder';
import './MiddleArea.css';

const MiddleArea = React.memo(({
    automDetail,
    setAutomDetail,
    isEhFlow,
    triggerDetail,
    setTriggerDetail,
    operationId,
    handleTrigger,
    handleDragStart,
    resetFlow,
    saveFlow,
    runFlow,
    debugFlow,
    tabFilter,
    setTabFilter,
    detailTabs,
    setDetailTabs,
    editFlow,
    isFocused,
    setOpenSchedule,
    setTriggerModal,
    triggerType,
    handleStart,
    handleStop,
    isRunning,
    trigger,
    setOpenDrive,
    publishFlow,
    debuggingStart,
    setDebuggingExpand,
    openRunningModal,
    setOpenDebugRunning,
    debuggingExpand,
    debugActionItemId,
    handleDiagramBuilder,
    handleRoi,
    findAndUpdateItem,
    isDiagramBuilder,
    diagramData,
    setIsDiagramBuilder,
    setDiagramData,
    setDialog,
    setOpenRoi,
    setShowRightArea,
    setShowTriggerRightArea,
    handleExport,
    handleImport,
    handleSlowMotion,
    setFlowStatus,
    handleErrorOpenClick,
    handleErrorCloseClick,
    variables,
    setOpenVariable,
    reCheck,
    setReCheck,
    openResetTriggerConfiguration,
    testAppStarted,
    handleTestAppCancel,
    automaticallyVariableCreation,
    automaticallyWhatsappVariableCreation,
    getVariables,
    updateVariableByItemId,
    setActiveItem,
    savedFlow,
    isDesktopRecorder,
    handleActions,
    desktopActionsEditDialog,
    handleDeleteAction,
    changeLabelField,
    resetWPSession, setIsWhatsappExist, setIsMSTeamsExist,
    setActions,
    handleOpenErrorHandlingAutom,
    handleDevMode,
    devMode,
}) => {
    let relativeX = 0, relativeY = 0, drag = false;
    let topFlow = 0;

    const handleDrag = useCallback((e) => {
        e.stopPropagation();
        if (e.target?.className && e.target?.className === "module-item-search-text module-search-text search-input-text") return
        drag = true;
        let rect = e.target.getBoundingClientRect();
        relativeX = e.clientX - rect.left;
        relativeY = e.clientY - rect.top;
        setTimeout(() => e.target.style.visibility = 'collapse', 10);
    }, [])

    const handleDrop = useCallback((e) => {
        e.stopPropagation();
        if (drag) {
            let rect = e.target.getBoundingClientRect();
            let x = e.clientX - rect.left - relativeX;
            let y = e.clientY - rect.top - relativeY;
            // const flow = document.getElementById('new-flow-drop-area-grid');
            const flow = !isDesktopRecorder ? document.getElementById('new-flow-drop-area-grid') : document.querySelector('.dialog-desktop-actions #new-flow-drop-area-grid');
            // const container = document.getElementById(isDesktopRecorder ? '.aaa #flow-container' : 'flow-container');
            const container = !isDesktopRecorder ? document.getElementById('flow-container') : document.querySelector('.dialog-desktop-actions #flow-container');
            if (x + container.scrollLeft <= 0) {
                flow.style.left = "0px";
            }
            else {
                flow.style.left = x + container.scrollLeft + 'px';
            }
            if (y + container.scrollTop <= 0) {
                flow.style.top = "0px";
            }
            else {
                flow.style.top = y + container.scrollTop + 'px';
            }
            flow.style.visibility = 'visible';
            drag = false;
        }
    }, [])

    const handleDragEnd = useCallback(() => {
        const flow = !isDesktopRecorder ? document.getElementById('new-flow-drop-area-grid') : document.querySelector('.dialog-desktop-actions #new-flow-drop-area-grid');
        flow.style.visibility = 'visible';
        drag = false;
        const conditionHover = document.getElementsByClassName("new-flow-drag-hover-condition");
        Array.prototype.forEach.call(conditionHover, function (el) {
            el.classList.remove('active');
        });
        const conditionHoverLines = document.getElementsByClassName("new-flow-horizontal-line-condition");
        Array.prototype.forEach.call(conditionHoverLines, function (el) {
            el.classList.remove('active');
        });
    }, [])

    const [isWheel, setIsWheel] = useState(false);

    useEffect(() => {
        const el = !isDesktopRecorder ? document.getElementById("flow-container") : document.querySelector('.dialog-desktop-actions #flow-container');
        el.addEventListener("wheel", (event) => {
            const flow = !isDesktopRecorder ? document.getElementById("new-flow-drop-area-grid") : document.querySelector('.dialog-desktop-actions #new-flow-drop-area-grid');
            const delta = Math.sign(event.deltaY);
            const offsetChangeValue = 50;
            const elem = !isDesktopRecorder ? document.getElementById("flow-stop") : document.querySelector('.dialog-desktop-actions #flow-stop');

            if (elem !== undefined && elem !== null) {
                const topPosition = flow.offsetTop;
                const flowStop = elem.offsetTop;

                if (delta === -1) {
                    if (topPosition < el.offsetHeight - 250) {
                        flow.style.top =
                            (topPosition + offsetChangeValue).toString() + "px";
                        topFlow = topPosition + offsetChangeValue;
                        setIsWheel(true);
                    }
                } else {
                    if (topPosition > -flowStop + 150) {
                        flow.style.top =
                            (topPosition - offsetChangeValue).toString() + "px";
                        topFlow = topPosition - offsetChangeValue;
                        setIsWheel(true);
                    }
                }
            }
        });


        el.addEventListener("keydown", (event) => {
            // const flow = document.getElementById("new-flow-drop-area-grid");
            const flow = !isDesktopRecorder ? document.getElementById("new-flow-drop-area-grid") : document.querySelector('.dialog-desktop-actions #new-flow-drop-area-grid');
            let offsetChangeValue = 50;
            const elem = document.getElementById("flow-stop");
            const actions = !isDesktopRecorder ? document.getElementsByClassName("drag-container-area")[0] : document.querySelectorAll('.dialog-desktop-actions .drag-container-area')[0];
            if (actions?.offsetHeight > 100 && actions?.offsetHeight < 250) offsetChangeValue = 100;
            else if (actions?.offsetHeight > 250 && actions?.offsetHeight < 500) offsetChangeValue = 200;
            else if (actions?.offsetHeight > 500 && actions?.offsetHeight < 750) offsetChangeValue = 325;
            else if (actions?.offsetHeight > 750 && actions?.offsetHeight < 1000) offsetChangeValue = 450;
            else if (actions?.offsetHeight > 1000 && actions?.offsetHeight < 1500) offsetChangeValue = 550;
            else if (actions?.offsetHeight > 1500 && actions?.offsetHeight < 2000) offsetChangeValue = 650;
            else if (actions?.offsetHeight > 2000 && actions?.offsetHeight < 2500) offsetChangeValue = 750;
            else if (actions?.offsetHeight > 2500 && actions?.offsetHeight < 3050) offsetChangeValue = 850;
            else if (actions?.offsetHeight > 3050 && actions?.offsetHeight < 4050) offsetChangeValue = 950;
            else if (actions?.offsetHeight > 4050 && actions?.offsetHeight < 5050) offsetChangeValue = 1100;
            else if (actions?.offsetHeight > 5050 && actions?.offsetHeight < 7050) offsetChangeValue = 1300;
            else if (actions?.offsetHeight > 7050 && actions?.offsetHeight < 10500) offsetChangeValue = 1500;
            else if (actions?.offsetHeight > 10500 && actions?.offsetHeight < 15000) offsetChangeValue = 1700;
            else if (actions?.offsetHeight > 15000) offsetChangeValue = 2000;
            if (elem !== undefined && elem !== null) {
                const topPosition = flow.offsetTop;
                const flowStop = elem.offsetTop;
                if (event.ctrlKey && event.keyCode === 35) {
                    if (topPosition > -flowStop + 150) {
                        flow.style.top =
                            (topPosition - offsetChangeValue).toString() + "px";
                        topFlow = topPosition - offsetChangeValue;
                        setIsWheel(true);
                    }
                } else if (event.ctrlKey && event.keyCode === 36) {
                    if (topPosition < el.offsetHeight - 250) {
                        flow.style.top =
                            (topPosition + offsetChangeValue).toString() + "px";
                        topFlow = topPosition + offsetChangeValue;
                        setIsWheel(true);
                    }
                }
            }
        })
    }, []);

    return (
        <div className="new-flow-middle-area" style={isDesktopRecorder ? { height: "100%", background: "#F3F3F3" } : null}>
            {!isDesktopRecorder &&
                <Header
                    automDetail={automDetail}
                    triggerDetail={triggerDetail}
                    operationId={operationId}
                    resetFlow={resetFlow}
                    saveFlow={saveFlow}
                    runFlow={runFlow}
                    setOpenDebugRunning={setOpenDebugRunning}
                    debugFlow={debugFlow}
                    debugActionItemId={debugActionItemId}
                    editFlow={editFlow}
                    setTriggerModal={setTriggerModal}
                    setOpenSchedule={setOpenSchedule}
                    triggerType={triggerType}
                    handleStop={handleStop}
                    handleStart={handleStart}
                    isRunning={isRunning}
                    trigger={trigger}
                    setOpenDrive={setOpenDrive}
                    publishFlow={publishFlow}
                    debuggingStart={debuggingStart}
                    setFlowStatus={setFlowStatus}
                    testAppStarted={testAppStarted}
                    handleTestAppCancel={handleTestAppCancel}
                    handleExport={handleExport}
                    handleImport={handleImport}
                    isDesktopRecorder={isDesktopRecorder}
                    automName={automDetail.name}
                    tabFilter={tabFilter}
                    setTabFilter={setTabFilter}
                    setDetailTabs={setDetailTabs}
                    detailTabs={detailTabs}
                    setDialog={setDialog}
                    handleDevMode={handleDevMode}
                    devMode={devMode}
                />}
            {!isDiagramBuilder ?
                <div className='diagram-buildder-container'>
                    <DiagramBuilder
                        isDiagramBuilder={isDiagramBuilder}
                        diagramData={diagramData}
                        setDiagramData={setDiagramData}
                        setIsDiagramBuilder={setIsDiagramBuilder}
                        setOpenRoi={setOpenRoi}
                    />
                </div> :
                <>
                    {/* {!isDesktopRecorder &&
                        <DetailTabs
                            automName={automDetail.name}
                            tabFilter={tabFilter}
                            setTabFilter={setTabFilter}
                            setDetailTabs={setDetailTabs}
                            detailTabs={detailTabs} />
                    } */}
                    <DropArea
                        handleDragStart={handleDragStart}
                        automDetail={automDetail}
                        setTriggerDetail={setTriggerDetail}
                        setAutomDetail={setAutomDetail}
                        handleTrigger={handleTrigger}
                        setDetailTabs={setDetailTabs}
                        detailTabs={detailTabs}
                        setTabFilter={setTabFilter}
                        isFocused={isFocused}
                        debuggingStart={debuggingStart}
                        openRunningModal={openRunningModal}
                        setDebuggingExpand={setDebuggingExpand}
                        debuggingExpand={debuggingExpand}
                        handleDiagramBuilder={handleDiagramBuilder}
                        isEhFlow={isEhFlow}
                        handleRoi={handleRoi} handleDrag={handleDrag} handleDragEnd={handleDragEnd}
                        findAndUpdateItem={findAndUpdateItem} handleDrop={handleDrop}
                        setActiveItem={setActiveItem}
                        setShowRightArea={setShowRightArea}
                        setShowTriggerRightArea={setShowTriggerRightArea}
                        handleImport={handleImport}
                        handleExport={handleExport}
                        handleSlowMotion={handleSlowMotion}
                        handleErrorOpenClick={handleErrorOpenClick}
                        handleErrorCloseClick={handleErrorCloseClick}
                        variables={variables}
                        setOpenVariable={setOpenVariable}
                        setReCheck={setReCheck} reCheck={reCheck}
                        openResetTriggerConfiguration={openResetTriggerConfiguration}
                        automaticallyVariableCreation={automaticallyVariableCreation}
                        setTriggerModal={setTriggerModal} setOpenSchedule={setOpenSchedule}
                        automaticallyWhatsappVariableCreation={automaticallyWhatsappVariableCreation}
                        getVariables={getVariables}
                        updateVariableByItemId={updateVariableByItemId}
                        savedFlow={savedFlow}
                        isDesktopRecorder={isDesktopRecorder}
                        handleActions={handleActions}
                        desktopActionsEditDialog={desktopActionsEditDialog}
                        handleDeleteAction={handleDeleteAction}
                        changeLabelField={changeLabelField}
                        resetWPSession={resetWPSession}
                        setIsWhatsappExist={setIsWhatsappExist}
                        setIsMSTeamsExist={setIsMSTeamsExist}
                        setActions={setActions}
                        handleOpenErrorHandlingAutom={handleOpenErrorHandlingAutom}
                        devMode={devMode}
                    />
                </>
            }
        </div>
    );
})
export default MiddleArea;
